import { render, staticRenderFns } from "./rwanak.vue?vue&type=template&id=4652a2c6"
import script from "./rwanak.vue?vue&type=script&lang=js"
export * from "./rwanak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports